import { DateTime } from 'luxon';
import { useIntl } from 'react-intl';

import { convertToCSV, downloadCSV, prepareCSVData } from './csv-utils';

/**
 * Custom hook that provides a function to export forecasting data to CSV
 * @returns {Function} A function that takes forecastingData and rawEntities and exports them to CSV
 */
export const useExportCSV = () => {
  const intl = useIntl();

  return (forecastingData, rawEntities) => {
    if (forecastingData.length === 0 || rawEntities.length === 0) {
      return;
    }

    const { headers, keys, data } = prepareCSVData(forecastingData, rawEntities, intl);
    const csvContent = convertToCSV(data, headers, keys);
    const currentDate = DateTime.now().toISODate(); // YYYY-MM-DD format
    const fileName = `shipstation-inventory-forecast-${currentDate}.csv`;
    downloadCSV(csvContent, fileName, intl);
  };
};
